<div
  class="dropdown"
  [ngClass]="{ 'is-visible': isOpen }"
  [attr.id]="dropdownId"
  (escHandler)="isOpen && close()"
>
  <button
    type="button"
    [disabled]="disabled"
    (click)="toggleDropdown($event)"
    class="dropdown-trigger"
    [attr.data-e2e-id]="e2eId"
    trackable
    [trackingObject]="trackingObject"
    [trackingAction]="trackingAction"
    [trackingAdditionalProperties]="trackingAdditionalProperties"
  >
    <div class="dropdown-trigger-contents">
      <div *ngIf="triggerIcon" class="trigger-icon-wrapper">
        <app-icon *ngIf="triggerIcon" [icon]="triggerIcon"> </app-icon>
      </div>

      <span *ngIf="triggerLabel" class="trigger-text">
        {{ triggerLabel }}
      </span>

      <span *ngIf="triggerBadge" class="trigger-badge">
        {{ triggerBadge }}
      </span>

      <div *ngIf="showChevron" class="chevron-icon-wrapper">
        <app-icon [icon]="chevronDownIcon"></app-icon>
      </div>
    </div>
  </button>

  <ul
    class="dropdown-contents"
    [hidden]="!isOpen"
    [attr.data-h-alignment]="hAlignment"
    [attr.data-v-alignment]="vAlignment"
  >
    <ng-container *ngFor="let dropdownItems of dropdownGroupedItems">
      <li
        *ngFor="
          let dropdownItem of dropdownItems;
          let first = first;
          let last = last
        "
        class="dropdown-contents-item"
        [ngClass]="{ 'first-group-item': first, 'last-group-item': last }"
      >
        <ng-template
          *ngTemplateOutlet="
            template;
            context: {
              dropdownItem: dropdownItem,
              closeCallback: closeCallback
            }
          "
        ></ng-template>
      </li>
    </ng-container>
  </ul>
</div>
